import { CompoundEntityRef } from '@backstage/catalog-model';
import { ResponseError } from '@backstage/errors';
import { BackendDeps, backendRequest } from './backend-request';

export type TechDocsBuildStatus = {
  status: 'failed' | 'skipped';
  error: string;
  commit: string;
  timestamp: number;
};

export async function fetchBuildStatus(
  { namespace, kind, name }: CompoundEntityRef,
  deps: BackendDeps,
): Promise<TechDocsBuildStatus | null> {
  const path = [namespace, kind, name]
    .map(value => encodeURIComponent(value.toLowerCase()))
    .join('/');
  try {
    return await backendRequest<TechDocsBuildStatus>(
      'techdocs',
      `/static/docs/${path}/techdocs_build_status.json`,
      deps,
    );
  } catch (error) {
    if (error instanceof ResponseError && error.statusCode === 404) {
      return null;
    }
    throw error;
  }
}
